import { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import {
  deleteBlog,
  getAuthorList,
  getBlogDetailsById,
  getBlogList,
  updateBlog,
  uploadBlogImage
} from "../adminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import moment from "moment";
import ImgPickerAndViewer from "../../../Component/imgPickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
import {
  validateAgeGrp,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import DateTimePicker from "../../../Component/dateTimePicker";
import TextEditor from "../../../Component/textEditor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DropdownWithClear from "../../../Component/dropdownWithClear";

const EditDeleteBlog = () => {
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [blogList, setBlogList] = useState<any>([]);
  const [title, setTitle] = useState<any>("");
  const [author, setAuthor] = useState<any>("");
  const [authorUrl, setAuthorUrl] = useState<any>("");
  const [slug, setSlug] = useState<any>("");
  const [dateTime, setDateTime] = useState<any>(
    moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
  );
  const [metaTitle, setMetaTitle] = useState<any>("");
  const [metaDesc, setMetaDesc] = useState<any>("");
  const [readingTime, setReadingTime] = useState<any>("");
  const [heroImage, setHeroImage] = useState<any>("");
  const [heroImagePreview, setHeroImagePreview] = useState<any>("");
  const [authorList, setAuthorList] = useState<any>([]);
  const [blogDetails, setBlogDetails] = useState<any>("");
  const [blogId, setBlogId] = useState<any>("");

  const initialVal = [
    {
      contentDescription: "",
      image: "",
      subTitle: "",
      imagePreview: ""
    },
  ];
  const [otherDetailsArr, setOtherDetailsArr] = useState<any>(initialVal);

  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    getData();
    dispatch(
      getAuthorList({
        callback: (res: any) => {
          setAuthorList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  }, []);

  const getData = () => {
    dispatch(
      getBlogList({
        callback: (res: any) => {
          setBlogList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  };

  const onchangeTitle = (value: any) => {
    setTitle(value);
  };
  const onchangeAuthor = (value: any) => {
    setAuthor(value);
  };
  const onchangeAuthorUrl = (value: any) => {
    setAuthorUrl(value);
  };
  const onchangeSlug = (value: any) => {
    setSlug(value);
  };
  const onchangeDateTime = (value: any) => {
    setDateTime(value);
  };
  const onchangeMetaTitle = (value: any) => {
    setMetaTitle(value);
  };
  const onchangeMetaDesc = (value: any) => {
    setMetaDesc(value);
  };
  const onchangeReadingTime = (value: any) => {
    if (validateAgeGrp(value)) {
      setReadingTime(value);
    }
  };
  const onchangeHeroImage = (value: any) => {
    if (!validateIsFileImageType(value)) {
      return;
    } else {
      const reader = new FileReader();
      const file = value.target.files[0];
      const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
      if (!mediaTypes.includes(file.type)) {
        console.error("Unsupported file type:", file.type);
        return;
      }
      reader.onloadend = () => {
        setHeroImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadBlogImage({
          params: file,
          callback: (res: any) => {
            if (res) {
              setHeroImage(res?.data?.name);
            }
          },
          errorCallback: () => { },
        })
      );
    }
  };
  const onchangeOtherDetails = (value: any, index: any, key: any) => {
    if (key === "image") {
      if (!validateIsFileImageType(value)) return;
      const reader = new FileReader();
      const file = value.target.files[0];
      reader.onloadend = () => {
        setOtherDetailsArr((prev: any) => {
          const updated = [...prev];
          updated[index] = {
            ...updated[index],
            imagePreview: reader.result,
          };
          return updated;
        });
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadBlogImage({
          params: file,
          callback: (res: any) => {
            if (res?.status === "success") {
              setOtherDetailsArr((prev: any) => {
                const updated = [...prev];
                updated[index] = {
                  ...updated[index],
                  [key]: res.data.name,
                };
                return updated;
              })
              // newArr[index][key] = res?.name;
              // setOtherDetailsArr(newArr);
            }
          },
          errorCallback: () => { },
        })
      );
    } else {
      setOtherDetailsArr((prev: any) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          [key]: value,
        };
        return updated;
      });
    }
  };

  const handleClose = (index: any) => {
    const newArrr = [...otherDetailsArr];
    if (index > -1) {
      newArrr.splice(index, 1);
    }
    setOtherDetailsArr(newArrr);
  };
  const onPressAdd = () => {
    setOtherDetailsArr([...otherDetailsArr, initialVal]);
  };
  const validations = () => {
    let valid = false;
    otherDetailsArr.map((item: any) => {
      if (
        item?.subtitle === "" ||
        item?.image === "" ||
        item?.description === ""
      ) {
        valid = true;
      }
    });
    if (title === "") {
      valid = true;
    }
    if (author === "") {
      valid = true;
    }
    if (slug === "") {
      valid = true;
    }
    if (dateTime === "") {
      valid = true;
    }
    if (metaTitle === "") {
      valid = true;
    }
    if (metaDesc === "") {
      valid = true;
    }
    if (readingTime === "") {
      valid = true;
    }
    if (heroImage === "") {
      valid = true;
    }
    return valid;
  };
  const renderTable = () => {
    return (
      <div>
        <AdminTable
          tableData={blogList ? blogList : []}
          pagename={"blogList"}
          tableHead={["S.N", "Name", "Action"]}
          handleEdit={(value: any) => handleEdit(value)}
          handleDelete={(value: any) => handleDelete(value)}
          edit={true}
        />
      </div>
    );
  };
  const handleEdit = (value: any) => {
    console.log("value", value);
    setisEditMode(true);
    setBlogId(value?._id);
    dispatch(
      getBlogDetailsById({
        id: value?._id,
        callback: (res: any) => {
          console.log("res", res);
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }))
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
            setBlogDetails(res?.data);
            setTitle(res?.data?.title);
            dispatch(
              getAuthorList({
                callback: (resp: any) => {
                  setAuthorList(resp?.data);
                  let tempAuthor = resp?.data?.filter(
                    (item: any) => res?.data?.authorId?._id === item?._id
                  );
                  setAuthor(tempAuthor[0]);
                },
                errorCallback: () => { },
              })
            );
            setAuthorUrl(res?.data?.authorUrl);
            setSlug(res?.data?.slug);
            setDateTime(
              moment
                .utc(res?.data?.dateTime)
                .utcOffset(330)
                .format("YYYY-MM-DD HH:mm:ss")
            );
            setMetaTitle(res?.data?.metaTitle);
            setMetaDesc(res?.data?.metaDescription);
            setReadingTime(res?.data?.timeOfreading);
            setHeroImage(res?.data?.heroImage);
            setOtherDetailsArr(res?.data?.details);
          }
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const handleDelete = (value: any) => {
    setisEditMode(false);
    dispatch(
      deleteBlog({
        id: value._id,
        callback: (res: any) => {
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
              getData();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const updatedOtherDetails = otherDetailsArr.map((item: any) => {
      const match = item.image?.match(/[^/]+$/);
      const filename = match ? match[0] : "";
      const { imagePreview, _id, ...rest } = item; return { ...rest, image: filename }
    });
    const postData: any = {};
    if (blogDetails?.title !== title) {
      postData["title"] = title;
    }
    if (blogDetails?.author?._id !== author?._id) {
      postData["authorId"] = author?._id;
    }
    if (blogDetails?.slug !== slug) {
      postData["slug"] = slug;
    }
    if (blogDetails?.dateTime !== dateTime) {
      postData["dateTime"] = dateTime;
    }
    if (blogDetails?.metaTitle !== metaTitle) {
      postData["metaTitle"] = metaTitle;
    }
    if (blogDetails?.metaDescription !== metaDesc) {
      postData["metaDescription"] = metaDesc;
    }
    if (blogDetails?.timeOfreading !== readingTime) {
      postData["timeOfreading"] = readingTime;
    }
    if (blogDetails?.heroImage !== heroImage) {
      postData["heroImage"] = heroImage;
    }
    if (JSON.stringify(blogDetails?.addMore) !== JSON.stringify(updatedOtherDetails)) {
      postData["details"] = updatedOtherDetails;
    }
    dispatch(
      updateBlog({
        id: blogId,
        params: postData,
        callback: (res: any) => {
          if (res?.data?.status === "success") {
            setisEditMode(false);
            dispatch(showSnackbar({ message: res?.data?.msg, type: res?.data?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
            setisEditMode(false);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row align-items-center ">
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Title"} isRequired />
            <InputField
              placeholder={"Enter Title"}
              setInputText={(value: any) => onchangeTitle(value)}
              value={title}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Author"} isRequired />
            <DropdownWithClear
              labelName={"Select Product Type"}
              setInputText={(value: any) => onchangeAuthor(value)}
              options={authorList}
              value={author}
            />
          </div>
          {/* <div className="col-md-4 mb-3">
            <LabelInput labelName={"Author URL"} isRequired />
            <InputField
              placeholder={"Enter Author URL"}
              setInputText={(value: any) => onchangeAuthorUrl(value)}
              value={authorUrl}
            />
          </div> */}
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Slug"} isRequired />
            <InputField
              placeholder={"Enter Slug"}
              setInputText={(value: any) => onchangeSlug(value)}
              value={slug}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Date & Time"} isRequired />
            <DateTimePicker
              setInputText={(value: any) => {
                onchangeDateTime(value);
              }}
              value={dateTime}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Meta Title"} isRequired />
            <InputField
              placeholder={"Enter Meta Title"}
              setInputText={(value: any) => onchangeMetaTitle(value)}
              value={metaTitle}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Meta Description"} isRequired />
            <InputField
              placeholder={"Enter Meta Description"}
              setInputText={(value: any) => onchangeMetaDesc(value)}
              value={metaDesc}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Reading Time (in minute)"} isRequired />
            <InputField
              placeholder={"Enter Reading Time in Minute"}
              setInputText={(value: any) => onchangeReadingTime(value)}
              value={readingTime}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Hero Image"} isRequired />
            <ImgPickerAndViewer
              handleChange={(value: any) => onchangeHeroImage(value)}
              value={heroImage || heroImagePreview}
            />
          </div>
          <div className="col-md-12">
            <div className=" ">
              {otherDetailsArr.map((item: any, index: any) => {
                return (
                  <div className=" d-flex mt-2 ">
                    <div className="col-md-11 pe-2 row d-flex border rounded p-4">
                      <div className="d-flex ">
                        <div className="me-3  ">
                          <LabelInput labelName={"Sub Title "} isRequired />
                          <InputField
                            key={"ex2"}
                            placeholder={"Enter Sub Title "}
                            setInputText={(value: any) =>
                              onchangeOtherDetails(value, index, "subTitle")
                            }
                            value={item?.subTitle}
                          />
                        </div>
                        <div className="me-3">
                          <LabelInput labelName={"Image"} isRequired />
                          <div className="">
                            <ImgPickerAndViewer
                              value={item?.imagePreview ? item?.imagePreview : item?.image}
                              handleChange={(value: any) =>
                                onchangeOtherDetails(value, index, "image")
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="me-3  ">
                        <LabelInput labelName={"Description "} isRequired />
                        <TextEditor
                          onChange={(value: any) =>
                            onchangeOtherDetails(
                              value,
                              index,
                              "contentDescription"
                            )
                          }
                          value={item?.contentDescription}
                        />
                      </div>
                    </div>
                    {otherDetailsArr.length === 1 ? null : (
                      <DeleteForeverIcon
                        className="cursor ms-3"
                        color="error"
                        fontSize="medium"
                        onClick={() => handleClose(index)}
                      />
                    )}
                  </div>
                );
              })}
              <div className="d-flex justify-content-end mt-4 ">
                <div className="col-3 ">
                  <AddMoreBtn handleClick={onPressAdd} />
                </div>
              </div>
              <div className="d-flex justify-content-center mt-3">
                <div className="col-2 pt-2">
                  <Submitbtn name={"Submit"} disabled={validations()} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };
  const handleGoBack = () => {
    setisEditMode(false);
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Blog"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv bxshadow">
        <div className=" p-2 borderRadius">
          {isEditMode ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteBlog;
